// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Tooltip_anchor__Mydsh","tooltip":"Tooltip_tooltip__vQvaH"};